import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Alert, Typography } from '@mui/material';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { adminApi } from '../../api/client';

export const FlowtaleDocs: React.FC = () => {
  const [spec, setSpec] = useState<object | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.getFlowtaleDocs()
      .then((res) => {
        setSpec(res.data);
      })
      .catch((err) => {
        setError(err.response?.data?.error || 'Kunne ikke hente API dokumentation');
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} mb={2}>
        Flowtale TMS API Dokumentation
      </Typography>
      <Box sx={{
        '& .swagger-ui .topbar': { display: 'none' },
        '& .swagger-ui': { fontFamily: 'inherit' },
        bgcolor: 'white',
        borderRadius: 2,
        overflow: 'hidden',
      }}>
        {spec && <SwaggerUI spec={spec} />}
      </Box>
    </Box>
  );
};

export default FlowtaleDocs;
